<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               :title="type" size="70%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="detail-wrap">
        <el-form ref="editForm" :model="formData">
          <div class="d-header">
            <div class="fl">
              <i class="el-icon-info"/>
              交货单号：<span v-if="formData.collectNo"
                             style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.collectNo }}</span>
              <span v-else class="information">待生成</span>

              <!-- 状态 -->
              <span v-if="formData.stat==1" class="information">待发货</span>
              <span v-if="formData.stat==3" class="information">已发货</span>
              <span v-if="formData.stat==99" class="information">取消</span>


            </div>
            <div class="fr">

            </div>
          </div>

          <div>

            <!-- 基本信息 -->
            <dix style="display: flex;  overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
              <div class="d-cont edit-mce-box" style="width: 98%;">
                <div class="d-item">
                  <div class="title first"><b>主信息</b></div>
                  <table class="table-detail">
                    <tbody>
                    <tr>
                      <th>
                        交货数量
                      </th>
                      <td>
                        {{ formData.qty }}
                      </td>

                      <th>
                        交货人工号
                      </th>
                      <td>
                        {{ formData.collecterWorker }}
                      </td>

                      <th>
                        交货人名称
                      </th>
                      <td>
                        {{ formData.collecter }}
                      </td>
                    </tr>

                    <tr>
                      <th>过帐时间</th>
                      <td>{{formData.accountTime}}</td>

                      <th>领料时间</th>
                      <td>{{formData.collectTime}}</td>

                      <th>物流公司名称</th>
                      <td>{{formData.deliverCompanyName}}</td>

                      <th>物流单号</th>
                      <td>{{formData.deliverNo}}</td>
                    </tr>

                    <tr>
                      <th>物流子单号</th>
                      <td>{{formData.deliverNoSub}}</td>

                      <th>总件数</th>
                      <td>{{formData.allQty}}</td>

                      <th>总重量</th>
                      <td>{{formData.allWeight}}</td>

                      <th>总体积</th>
                      <td>{{formData.allVolume}}</td>
                    </tr>

                    <tr>
                      <th>揽收时间</th>
                      <td>{{formData.collectingDate}}</td>

                      <th>预计到达时间</th>
                      <td>{{formData.etaDate}}</td>

                      <th>最新路由信息</th>
                      <td>{{formData.newDeliverInfo}}</td>

                      <th>签收时间</th>
                      <td>{{formData.deliverSignTime}}</td>
                    </tr>

                    <tr>
                      <th>
                        外部交货单号
                      </th>
                      <td>
                        {{ formData.send1No }}
                      </td>

                      <th>交货同步状态</th>
                      <td v-if="formData.send1Flag == 1">失败</td>
                      <td v-else-if="formData.send1Flag == 2">已传</td>
                      <td v-else-if="formData.send1Flag == 3">取消</td>
                      <td v-else-if="formData.send1Flag == 0">未传</td>
                      <td v-else>未传</td>

                      <th>交货同步时间</th>
                      <td>{{ formData.send1Date }}</td>

                      <th>交货同步备注</th>
                      <td>{{ formData.send1Message }}</td>
                    </tr>

                    <tr>
                      <th>外部发货单号</th>
                      <td>{{ formData.send2No }}</td>

                      <th>发货同步状态</th>
                      <td v-if="formData.send2Flag == 1">失败</td>
                      <td v-else-if="formData.send2Flag == 2">已传</td>
                      <td v-else-if="formData.send2Flag == 3">取消</td>
                      <td v-else-if="formData.send2Flag == 0">未传</td>
                      <td v-else>未传</td>

                      <th>发货同步时间</th>
                      <td>{{ formData.send2Date }}</td>

                      <th>发货同步备注</th>
                      <td>{{ formData.send2Message }}</td>
                    </tr>

                    <tr>
<!--                      <th>收货人</th>-->
<!--                      <td>{{formData.deliverMan}}</td>-->

<!--                      <th>收货人电话</th>-->
<!--                      <td>{{formData.deliverMobile}}</td>-->

                      <th>打印次数</th>
                      <td>{{formData.printNum}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div class="d-item">
                  <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;">
                    <div class="title first"><b>申请明细</b></div>
                    <div class="item-button" style="margin-top: 8px;"></div>
                  </div>
                  <div>
                    <vxe-table
                      style="margin-top: 0px;"
                      :stripe="true"
                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                      :row-config="{height: 30,isHover: true,padding: 0,}"
                      :row-style="{ fontSize: '12px',  }"
                      show-overflow
                      height="230"
                      :column-config="{ resizable: true }"
                      :data="formData.spPartsApplyCollectLineDTOList">
                      <vxe-column type="checkbox" width="40"/>
                      <vxe-column field="partsCode" title="配件编码" width="130"></vxe-column>
                      <vxe-column field="partsName" title="配件名称" width="130"></vxe-column>
                      <vxe-column field="lineId" title="行号" width="100"></vxe-column>
                      <vxe-column field="lineId1" title="回传行号" width="100"></vxe-column>
                      <vxe-column field="checkQty" title="交货数量" width="100"></vxe-column>
                      <vxe-column field="qty" title="回传交货数量" width="100"></vxe-column>
<!--                      <vxe-column field="qty" title="交货数量" width="100"></vxe-column>-->
                      <vxe-column field="outQty" title="发货数量" width="100"></vxe-column>
                      <vxe-column field="sitePrice" title="价格" width="100"></vxe-column>
                      <vxe-column field="applyNo" title="申请单号" width="200"></vxe-column>
                    </vxe-table>
                  </div>
                </div>
              </div>
            </dix>
          </div>
        </el-form>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import CollectInfo from "@/views/accessories/applyFor/apply/collectInfo.vue";

export default {
  name: 'collectInfoDialog',
  components: {CollectInfo},
  props: ['multi', 'dataId'],
  created() {
    this.formData.id = this.dataId
  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      formData: {
        id: null,
      },
      drawer: true,

    }
  },
  methods: {
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.$http.post(api.spPartsApplyCollectHeader.getDataUrl, {id: this.dataId}).then(response => {
          this.formData = response.data.data
        })
      }
    },

    close() {
      // this.$mask.open()
      // this.$http({
      //   url: api.spPartsApplyHeader.commitUrl,
      //   method: 'post',
      //   data: this.formData
      // }).then(res => {
      //   this.$mask.close()
      //   this.$message.success('操作成功')
      //   this.visiable = false
      //   this.$emit('update:visiable', this.visiable)
      //   this.$emit('goBackIndex')
      // }).catch(() => {
      //   this.$mask.close()
      // })
    },

    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
      this.$emit('closeD')

    },
    handleClose() {
      this.cancelForm()
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
